/**
 * Google Ads dönüşüm takibi — teklif formu (QuoteModal) gönderimi.
 *
 * Hesap:    Can ÖZEN International Event Management (694-605-8323)
 * Etiket:   AW-17634747223  (index.html içinde yüklü)
 * Dönüşüm:  "Canozen Teklif Formu Kod (canozen.com.tr)" — Submit lead form
 *
 * CONVERSION_LABEL boş olduğu sürece dönüşüm olayı GÖNDERİLMEZ (güvenli varsayılan).
 */
const CONVERSION_ID = "AW-17634747223";
const CONVERSION_LABEL = "h184CNPd7tEcENfG89hB";
const CONVERSION_VALUE = 1.0;
const CONVERSION_CURRENCY = "TRY";

type GtagWindow = Window & { gtag?: (...args: unknown[]) => void };

/** Teklif formu başarıyla gönderildiğinde Google Ads dönüşümünü tetikler. */
export function trackQuoteFormConversion(): void {
  if (!CONVERSION_LABEL) return;
  const w = window as GtagWindow;
  if (typeof w.gtag !== "function") return;
  w.gtag("event", "conversion", {
    send_to: `${CONVERSION_ID}/${CONVERSION_LABEL}`,
    value: CONVERSION_VALUE,
    currency: CONVERSION_CURRENCY,
  });
}
